import React from 'react';
import { Spinner } from 'react-bootstrap';
import { Layout } from '../common/components/Layout';
import { AppInsightsContextProvider } from './AppInsightsContext';
import withAppInsights from './AppInsights';
import { useAuthUser } from '../features/auth/authHooks';
import AppRoutes from './AppRoutes';

function App() {
  const { isLoading, isLoggedIn, hasPermissions, loginUrl, logoutUrl } =
    useAuthUser();

  if (isLoading) {
    return (
      <div
        className="d-flex w-100 justify-content-center align-items-center"
        style={{ height: '100vh' }}
      >
        <div className="d-flex gap-16 align-items-center">
          <Spinner animation="border" /> Kirjaudutaan sisään...
        </div>
      </div>
    );
  }
  if (!isLoading && isLoggedIn && !hasPermissions) {
    return (
      <div
        className="d-flex w-100 justify-content-center align-items-center"
        style={{ height: '100vh' }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 col-xl-5">
              <div className="card shadow">
                <div className="card-body text-center">
                  <h1 className="h4 mb-16 d-flex align-items-center justify-content-center">
                    <span className="text-danger bi bi-exclamation-triangle me-16 fs-1" />
                    Pääsy evätty
                  </h1>
                  <p>Sinulla ei ole oikeuksia tähän palveluun.</p>
                  <a href={logoutUrl}>Kokeile kirjautua uudelleen sisään</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  if (!isLoading && !isLoggedIn) {
    window.location.href = loginUrl;
    return null;
  }
  const redirectAfterLogin = localStorage.getItem('redirectAfterLogin');
  if (redirectAfterLogin != null) {
    window.location.href = redirectAfterLogin;
    localStorage.removeItem('redirectAfterLogin');
  }
  return (
    <AppInsightsContextProvider>
      <Layout>
        <AppRoutes />
      </Layout>
    </AppInsightsContextProvider>
  );
}

export default withAppInsights(App);
